<template>
    <v-row no-gutters justify="center" align-content="center" class="pa-5" style="height: 100%;">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <template v-if="!isViewReady">
                <v-row style="height: 100%" align="center" justify="center">
                    <!-- NOTE: we use this app-splash-loader instead of v-progress-circular because we want this to look exactly like the index.html splash loader so the visual transition is smooth for the user as the rest of the UI loads -->
                    <div class="app-splash-loader"></div>
                </v-row>
            </template>
            <template v-if="interactionError">
                <v-alert type="error">
                    We cannot process this request.
                </v-alert>
            </template>
            <template v-if="tokenError">
                <v-alert border="left" color="red darken-2" colored-border>
                    The link was invalid or expired.
                </v-alert>
            </template>
            <template v-if="errorUnauthorizedInteraction">
                <v-alert type="error">
                    Unauthorized
                </v-alert>
                <!-- <p class="text-h5 font-weight-light red--text">Unauthorized</p> -->
                <p class="text-h5 font-weight-light mt-6">Did you start in another browser? Try opening the link in that browser, or start over in this one.</p>
                <p class="text-body-1 font-weight-light text-center"><router-link :to="{ name: 'front' }">Start over</router-link></p>
            </template>
            <template v-if="serverError">
                <v-alert type="error">
                    We cannot process this request due to a temporary server error. Reload the page to try again. If it&apos;s not resolved in a few minutes, please contact customer support.
                </v-alert>
            </template>
        </v-col>
    </v-row>
</template>
<style lang="css">
.app-splash-loader {
    border: 4px solid #e1bee7; /* purple lighten-4 */
    border-top: 4px solid #9c27b0; /* purple */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1.0s linear infinite;
    margin: auto;
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
<script>
import { mapState /* , mapGetters */ } from 'vuex';
// import { client } from '@/client';

// constants
const IA_LOGIN = 'login';
const IA_SIGNUP = 'signup';
const INTENT_LOGIN = 'login';
const INTENT_SIGNUP = 'signup';
const ROUTE_LOGIN = 'login';
const ROUTE_SIGNUP = 'signup';
const ROUTE_FRONT = 'front';

export default {
    components: {
    },
    data: () => ({
        isViewReady: false,
        intent: null, // login or signup
        email: false, // login and signup interactions may include an email address that we need to forward to next step
        product: null, // signup interaction may include a product lookup key that we need to forward to next step
        interactionId: null,
        interactionError: false,
        errorUnauthorizedInteraction: false,
        serverError: false,
        tokenError: false,
    }),
    computed: {
        ...mapState({
            isAuthenticatedReady: (state) => state.isReady,
            session: (state) => state.session,
        }),
        isAuthenticated() {
            return this.session.isAuthenticated;
        },
        isError() {
            return this.serverError || this.interactionError || this.errorUnauthorizedInteraction;
        },
    },
    methods: {
        async init() {
            console.log('interaction.vue: init; isAuthenticated: %o', this.isAuthenticated);
            // if (this.$route.query.cryptium_id_token) {
            //     await this.resumeFromCryptiumId(this.$route.query.cryptium_id_token);
            // }
            // if (this.$route.query.etherlink_profile_token) {
            //     await this.resumeFromEtherLink(this.$route.query.etherlink_profile_token);
            // }
            if (this.$route.query.token) {
                await this.resumeInteraction(this.$route.query.token);
            }
            if (this.interactionId === null && this.$route.query.i) {
                this.interactionId = this.$route.query.i;
            }
            if (this.interactionId) {
                await this.loadInteraction(this.interactionId);
            }
            if (this.intent === null && this.$route.query.intent) {
                this.intent = this.$route.query.intent;
            }
            if (this.intent) {
                this.resumeIntent(this.intent);
            }
            this.isViewReady = true;
        },
        /**
         * Called when user returns from EtherLink with `etherlink_profile_token`
         */
        // async resumeFromEtherLink(token) {
        // try {
        //     this.$store.commit('loading', { resumeFromEtherLink: true });
        //     const request = {
        //         etherlink_token: token,
        //     };
        // },
        /**
         * Called when user returns from Cryptium ID with `cryptium_id_token`
         */
        /*
        async resumeFromCryptiumId(token) {
            try {
                this.$store.commit('loading', { resumeFromCryptiumId: true });
                const request = {
                    cryptium_id_token: token,
                };
                console.log(`resumeFromCryptiumId request ${JSON.stringify(request)}`);
                const response = await this.$client.main().authn.checkVerifyEmail(request);
                console.log(`resumeFromCryptiumId response ${JSON.stringify(response)}`);
                const { type, fault, intent, intent_params: intentParams } = response;
                if (type === 'fault') { // TODO: use constant  like RESPONSE_TYPE_FAULT
                    console.error(`activate: server returned fault: ${JSON.stringify(fault)}`);
                    this.tokenError = true;
                    return;
                }
                if (type === 'intent') { // TODO: use constant  like RESPONSE_TYPE_INTENT
                    switch (intent) {
                    case 'login': { // TODO: use constant like INTENT_LOGIN
                        const { id, email } = intentParams;
                        this.$router.replace({ name: 'realm-login', params: { realm: this.$route.params.realm }, query: { r: id, email } });
                        return;
                    }
                    case 'redirect': { // TODO: use constant like INTENT_REDIRECT
                        const { redirect } = intentParams;
                        if (!redirect) {
                            console.error('activate: intent redirect did not include redirect param');
                            this.tokenError = true;
                            return;
                        }
                        console.log(`activate: redirect ${redirect}`);
                        if (typeof window.location.replace === 'function') {
                            window.location.replace(redirect);
                        } else {
                            window.location.href = redirect;
                        }
                        return;
                    }
                    default:
                        console.log(`activate: unrecognized intent ${intent}`);
                        this.tokenError = true;
                    }
                }
                // switch (response?.status) {
                // case 'verified_email':
                //     if (response.email) {
                //         this.email = response.email;
                //     }
                //     break;
                // case 'error':
                //     this.serverError = true;
                //     this.serverErrorTimeout = setTimeout(() => { this.serverError = null; }, 15000); // clear message in 15 seconds
                //     break;
                // default:
                //     console.error(`signup error: unexpected status from server: ${JSON.stringify(response.status)}`);
                //     this.serverError = true;
                //     this.serverErrorTimeout = setTimeout(() => { this.serverError = null; }, 15000); // clear message in 15 seconds
                // }
            } catch (err) {
                console.error('failed to verify email', err);
                if (err.response?.status) {
                    console.error(`response status: ${err.response.status}`);
                    // TODO: 300 error codes? server shouldn't be redirecting us...
                    if (err.response.status >= 400 && err.response.status < 500) {
                        this.requestError = true;
                        this.requestErrorTimeout = setTimeout(() => { this.requestError = false; }, 15000); // clear message in 15 seconds
                    } else if (err.response.status >= 500) {
                        this.serverError = true;
                        this.serverErrorTimeout = setTimeout(() => { this.serverError = false; }, 15000); // clear message in 15 seconds
                    } else {
                        // TODO: change to unknownError?
                        this.serverError = true;
                        this.serverErrorTimeout = setTimeout(() => { this.serverError = false; }, 15000); // clear message in 15 seconds
                    }
                } else {
                    // TODO: change to unknownError?
                    this.serverError = true;
                    this.serverErrorTimeout = setTimeout(() => { this.serverError = false; }, 15000); // clear message in 15 seconds
                }
            } finally {
                this.$store.commit('loading', { resumeFromCryptiumId: false });
            }
        },
        */
        async resumeInteraction(token) {
            try {
                this.$store.commit('loading', { resumeInteraction: true });
                const response = await this.$client.main().interaction.resume(token);
                console.log(`resumeInteraction response: ${JSON.stringify(response)}`);
                const { interaction_id: interactionId, next_route: nextRoute, error } = response;
                if (error) {
                    this.interactionError = true;
                } else if (nextRoute) {
                    console.log(`resumeInteraction nextRoute: ${JSON.stringify(nextRoute)}`);
                    this.$router.replace(nextRoute);
                } else {
                    this.interactionId = interactionId;

                    // since the destination route is the same, we expect all the state to remain,
                    // but put it in the URL just in case it is cleared by the navigation
                    const query = {
                        i: interactionId,
                        email: this.email,
                        product: this.product,
                    };

                    this.$router.replace({ name: 'interaction', query });
                }
            } catch (err) {
                console.error('failed to activate token', err);
                this.serverError = true;
            } finally {
                this.$store.commit('loading', { resumeInteraction: false });
            }
        },
        async loadInteraction(interactionId) {
            try {
                this.$store.commit('loading', { loadInteraction: true });
                const response = await this.$client.main().interaction.get(interactionId);
                console.log(`loadInteraction response: ${JSON.stringify(response)}`);
                const { type, /* next, */ state = {} } = response;
                console.log(`interaction.vue: loadInteraction: interaction type: ${type} state ${JSON.stringify(state)}`);
                // switch (type) {
                // case 'create_account':
                //     this.createAccount({ type, next, state }, prevInteraction);
                //     break;
                // default:
                //     console.error('interaction.vue: unknown interaction type: %s', type);
                //     this.interactionError = true;
                //     break;
                // }
                // TODO: so if it's login, redirect to login; if it's sign up , redirect to sign up  ...  or jsut set this.intent and this.intentData (to use as query parameters) and let resumeIntent do that redirect.
                let intent = null;
                switch (type) {
                case IA_LOGIN:
                    intent = INTENT_LOGIN;
                    break;
                case IA_SIGNUP:
                    intent = INTENT_SIGNUP;
                    if (state.email) {
                        this.email = state.email;
                    }
                    if (state.product) {
                        this.product = state.product;
                    }
                    // this.display_name = state.display_name;
                    break;
                default:
                    console.error(`unexpected interaction type: ${JSON.stringify(type)}`);
                    break;
                }
                if (intent) {
                    this.intent = intent;
                }
            } catch (err) {
                console.error('failed to activate token', err);
            } finally {
                this.$store.commit('loading', { loadInteraction: false });
            }
        },
        resumeIntent(intent) {
            // query parameter values may be null depending on how user arrived
            const query = {};
            if (this.email) {
                query.email = this.email;
            }
            if (this.product) {
                query.product = this.product;
            }
            if (this.interactionId) {
                query.i = this.interactionId;
            }
            switch (intent) {
            case INTENT_LOGIN:
                this.$router.replace({ name: ROUTE_LOGIN, query });
                break;
            case INTENT_SIGNUP:
                query.step = 'display_name';
                this.$router.replace({ name: ROUTE_SIGNUP, query });
                break;
            default:
                this.$router.replace({ name: ROUTE_FRONT, query });
                break;
            }
        },
        // createAccount({ state }) {
        //     const { isVerified, isExisting } = state;
        //     if (isExisting) {
        //         this.$router.replace({ path: '/create-account/conflict', query: { i: this.interactionId } });
        //         return;
        //     }
        //     if (isVerified) {
        //         this.$router.replace({ path: '/create-account/login', query: { i: this.interactionId } });
        //         return;
        //     }
        //     this.interactionError = true;
        // },
    },
    // created() {
    //     if (this.$route.query.error) {
    //         console.log(`interaction.vue: created, error: ${this.$route.query.error}`);
    //         this.loading = false;
    //         switch (this.$route.query.error) {
    //         case 'unauthorized':
    //             this.errorUnauthorizedInteraction = true;
    //             break;
    //         default:
    //             this.interactionError = true;
    //         }
    //     } else {
    //         this.interactionId = this.$route.query.i;
    //         console.log(`interaction.vue: created, interactionId: ${this.interactionId}`);
    //     }
    // },
    mounted() {
        this.init();
    },
};
</script>
